import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import constitutionImage from "../../../images/Constitution/Constitution_01.jpg";
import constitutionImage2 from "../../../images/Constitution/Constitution_02.jpg";
import constitutionImage3 from "../../../images/Constitution/Constitution_03.jpg";
import constitutionImage4 from "../../../images/Constitution/Constitution_04.jpg";
import constitutionImage5 from "../../../images/Constitution/Constitution_05.jpg";
import constitutionImage6 from "../../../images/Constitution/Constitution_06.jpg";
import constitutionImage7 from "../../../images/Constitution/Constitution_07.jpg";
import constitutionImage8 from "../../../images/Constitution/Constitution_08.jpg";
import constitutionImage9 from "../../../images/Constitution/Constitution_09.jpg";
import constitutionImage10 from "../../../images/Constitution/Constitution_10.jpg";
import constitutionImage11 from "../../../images/Constitution/Constitution_11.jpg";
import "../../../style/about/constitution.css";
import TranslateButton from "../../TranslateButton/TranslateButton";

const Constitution = () => {
  useEffect(() => {
    document.title = `Development Concern | Constitution`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/about/constitution";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="constitution_section">
        <div className="header_image">
          <p>Home | About | Governance & Policies</p>
          <h2>Constitution</h2>
        </div>

        <div className="container">
          <div className="image_wrapper">
            <img src={constitutionImage} loading="lazy" alt="" />
            <img src={constitutionImage2} loading="lazy" alt="" />
            <img src={constitutionImage3} loading="lazy" alt="" />
            <img src={constitutionImage4} loading="lazy" alt="" />
            <img src={constitutionImage5} loading="lazy" alt="" />
            <img src={constitutionImage6} loading="lazy" alt="" />
            <img src={constitutionImage7} loading="lazy" alt="" />
            <img src={constitutionImage8} loading="lazy" alt="" />
            <img src={constitutionImage9} loading="lazy" alt="" />
            <img src={constitutionImage10} loading="lazy" alt="" />
            <img src={constitutionImage11} loading="lazy" alt="" />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Constitution;
